import { ProjectsPaywallProps } from '@components/ProjectsPaywall';
import { ColumnDef } from '@tanstack/react-table';
import { LeadType } from '@utils/types';

import { Author } from './authors';
import { Article } from './homepage';

export interface ProjectData<TData, TValue> {
  columns: ColumnDef<TData, TValue>[];
  data: TData[];
  hiddenCols: string[];
  pinnedCols: string[];
  sortCols: string[];
}

export interface RawProjectData {
  [key: string]: string | number;
}

export interface Project {
  article?: Pick<Article, 'id' | 'publishedAt' | 'slug' | 'title' | 'newsletterSlug'>;
  accessLevel: number;
  authors: Author[];
  byline?: string;
  description: string;
  id: number;
  isPro: boolean;
  leadType: LeadType;
  notes?: string;
  slug: string;
  theme: ProjectTheme;
  title: string;
  titleCallout: string;
  updatedAt: string;
}

export interface ProjectMedia {
  elementId: string;
  height: number;
  id: number;
  layout: ProjectMediaLayout;
  mediaType: ProjectMediaType;
  order: number;
  src: string;
  style: string;
  title: string;
}

export interface TalentTrackerSidebarItem {
  title: string;
  url?: string;
  section: 'takeaways' | 'read more';
}

interface TalentTrackerData {
  categories: Pick<Project, 'title' | 'slug'>[];
  profiles: RawProjectData[];
  sidebarItems: TalentTrackerSidebarItem[];
}

export interface TalentTrackerProps {
  data: TalentTrackerData;
  paywallData: ProjectsPaywallProps;
  project: Project;
  unlocked: boolean;
}

export interface DatabaseProps<TData, TValue> {
  data: ProjectData<TData, TValue>;
  paywallData: ProjectsPaywallProps;
  project: Project;
  projectMedia?: ProjectMedia[];
  unlocked: boolean;
}

type CustomColumnDef<TData, TValue> = ColumnDef<TData, TValue> & {
  merge?: string;
};

export type ProjectColumnConfigFn = <TData, TValue>(
  column: CustomColumnDef<TData, TValue>
) => CustomColumnDef<TData, TValue>;

export enum ProjectTheme {
  Database = 'database',
  TalentTracker = 'talent_tracker',
}

export enum ProjectMediaLayout {
  Standard = 'standard',
  FullWidth = 'full_width',
}

export enum ProjectMediaType {
  Iframe = 'iframe',
  Image = 'image',
}
